/*
 * Ryan O'Dowd
 * 2025-07-05
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React from 'react';
import Title from '../Title';
import getStyles from './styles';
import hooks from '@hooks';

const Subtitle = (props: React.ComponentProps<typeof Title>) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <Title
      {...props}
      style={[styles.container, props.style]}
    >
      {props.children}
    </Title>
  );
};

export default Subtitle;
